"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeasingPhoneNumberForRegion = exports.formatPhoneForDisplay = exports.format = void 0;
const regions_1 = require("./regions");
const format = (phone) => {
    if (!phone) {
        return null;
    }
    let to = phone.replace(/\D/g, '');
    if (to.length === 10) {
        to = `+1${to}`;
    }
    else if (to.length === 11 && to[0] === '1') {
        to = `+${to}`;
    }
    else if (to.length !== 12 || to.substring(0, 2) !== '+1') {
        return null;
    }
    return to;
};
exports.format = format;
const formatPhoneForDisplay = (phone) => {
    if (!phone) {
        return null;
    }
    const sanitizedPhone = (0, exports.format)(phone);
    const tenDigits = sanitizedPhone === null || sanitizedPhone === void 0 ? void 0 : sanitizedPhone.replace('+1', '');
    if (!tenDigits || tenDigits.length !== 10) {
        return null;
    }
    // Format as (XXX) XXX-XXXX
    return `(${tenDigits.slice(0, 3)}) ${tenDigits.slice(3, 6)}-${tenDigits.slice(6)}`;
};
exports.formatPhoneForDisplay = formatPhoneForDisplay;
const getLeasingPhoneNumberForRegion = (region) => {
    if (region === null) {
        throw new Error('Missing region.');
    }
    switch (region) {
        case regions_1.REGIONS.ST_LOUIS:
            return '+13142933909';
        case regions_1.REGIONS.CHARLOTTE:
        case regions_1.REGIONS.RALEIGH:
            return '+17042597856';
        case regions_1.REGIONS.LOS_ANGELES:
            return '+12132972604';
        case regions_1.REGIONS.ATLANTA:
            return '+14043902224';
        case regions_1.REGIONS.INDIANAPOLIS:
            return '+14632175705';
        case regions_1.REGIONS.HUNTSVILLE:
            return '+12566432926';
        case regions_1.REGIONS.KANSAS_CITY:
            return '+18164761554';
        default:
            throw new Error(`Cannot get phone number from region: ${region}.`);
    }
};
exports.getLeasingPhoneNumberForRegion = getLeasingPhoneNumberForRegion;
